import React from 'react';
import { Link } from 'react-router-dom';

import { IdentityProvider } from '~components/identity-providers/identity-provider-prop-types';

export default function IdentityProviderLink({ identityProvider }) {
  if (!identityProvider) {
    return null;
  }
  return (
    <Link to={{ pathname: `/identity-providers/${identityProvider.id}`, state: { identityProvider } }}>
      {identityProvider.name}
    </Link>
  );
}

IdentityProviderLink.propTypes = {
  identityProvider: IdentityProvider
};
